import React from 'react';
import { ChevronRight } from 'lucide-react';

/**
 * Viewed, gallery, saved, enquired, attended, offered.
 * Clicking a stage lists the buyers inside it.
 *
 * Conversion is measured against the stage above it. Buyers can skip a step
 * (enquire without saving, for example), so a stage can read above 100%.
 */
export default function BuyerFunnel({ funnel = [], onStageClick }) {
    if (!funnel.length) return null;
    const top = funnel[0]?.count || 0;

    return (
        <div className="space-y-2">
            {funnel.map((stage, index) => {
                const width = top ? Math.max(2, (stage.count / top) * 100) : 0;
                const clickable = stage.count > 0 && typeof onStageClick === 'function';
                return (
                    <button
                        key={stage.key}
                        type="button"
                        onClick={() => clickable && onStageClick(stage)}
                        disabled={!clickable}
                        className={`flex w-full items-center gap-3 rounded-xl border border-gray-200 bg-white px-3 py-2.5 text-left transition ${
                            clickable ? 'hover:border-[#55C5D0] hover:shadow-sm' : 'cursor-default opacity-70'
                        }`}
                    >
                        <span className="min-w-0 flex-1 sm:w-40 sm:flex-none text-sm font-semibold text-[#374151]">
                            {stage.label}
                        </span>
                        <span className="w-14 shrink-0 text-lg font-extrabold text-[#374151]">
                            {stage.count}
                        </span>
                        <span className="hidden h-3 flex-1 rounded-full bg-gray-100 sm:block">
                            <span
                                className="block h-3 rounded-full bg-gradient-to-r from-[#55C5D0] to-[#3a99a3]"
                                style={{ width: `${width}%` }}
                            />
                        </span>
                        <span className="w-28 shrink-0 text-right text-xs font-semibold text-gray-500">
                            {index === 0
                                ? '100% of viewers'
                                : stage.conversion_from_previous === null
                                    // Nobody reached the stage above, so fall back to
                                    // the share of everyone who viewed the property.
                                    ? `${stage.share_pct}% of viewers`
                                    : `${stage.conversion_from_previous}% of previous`}
                        </span>
                        {clickable && <ChevronRight size={14} className="shrink-0 text-gray-400" />}
                    </button>
                );
            })}
        </div>
    );
}
